import config from './config';
import skinner from './utils/skinner';

const skin = skinner(config.skin || {}, config.theme.color);

export default skin;
